export const authorities = ['ROLE_ADMIN', 'ROLE_COUNCIL_ADMIN', 'ROLE_COUNCIL_USER'] as const;
export type AuthorityType = (typeof authorities)[number];

export const userTypes = ['ADMIN', 'COUNCIL_ADMIN', 'COUNCIL_USER'] as const;
export type UserType = (typeof userTypes)[number];

export const bankCategoryTypes = ['CREDIT_ENTITY', 'CENTRAL_BANK', 'MONEY_MARKET_FUND', 'ANOTHER_INSTITUTION'] as const;
export type BankCategoryType = (typeof bankCategoryTypes)[number];

export const positionTypes = ['MAYOR', 'FINANCE_COUNCILOR', 'INTERVENING_SECRETARY', 'TREASURER', 'ADMINISTRATIVE'] as const;
export type PositionType = (typeof positionTypes)[number];

export const statusTypes = ['ENABLED', 'DISABLED'] as const;
export type StatusType = (typeof statusTypes)[number];

export const taxTypes = ['IBI', 'GARBAGE', 'IVTM'] as const;
export type TaxType = (typeof taxTypes)[number];

export const phaseTypes = ['APREMIO', 'SEIZURE'] as const;
export type PhaseType = (typeof phaseTypes)[number];

export const periodTypes = ['T_1', 'T_2', 'T_3', 'T_4'] as const;
export type PeriodType = (typeof periodTypes)[number];

export const stateTypes = [
    'REGISTERED',
    'INITIALIZED',
    'NOTIFICATION_BUILD',
    'NOTIFICATION_SIGN',
    'NOTIFICATION_SENT',
    'NOTIFICATION_RECEIVED',
    'NOTIFICATION_ABSENT',
    'NOTIFICATION_WRONG_ADDRESS',
    'NOTIFICATION_UNKNOWN',
    'ANNOUNCEMENT_BUILD',
    'ANNOUNCEMENT_SENT',
    'ANNOUNCEMENT_PUBLISHED',
    'EMBARGO_INITIALIZED',
    'EMBARGO_BANK_ACCOUNT',
    'CANCELLED',
    'PAID'
] as const;
export type StateType = (typeof stateTypes)[number];

export const legalEntityTypes = ['NATURAL', 'JURIDICAL'] as const;
export type LegalEntityType = (typeof legalEntityTypes)[number];

export const taxpayerVersionActionTypes = ['CREATE', 'UPDATE', 'DELETE'] as const;
export type TaxpayerVersionActionType = (typeof taxpayerVersionActionTypes)[number];

export const menus = ['dashboard', 'users', 'settings', 'taxes', 'councils', 'taxpayers', 'banks', 'nationalParameters'] as const;
export type MenuType = (typeof menus)[number];

export const embargoBankAccountInfoRequestStateTypes = ['SENT', 'FAILED'] as const;
export type EmbargoBankAccountInfoRequestStateType = (typeof embargoBankAccountInfoRequestStateTypes)[number];

export const receivableEmbargoBankAccountBankPhaseTypes = ['PHASE_1', 'PHASE_2', 'PHASE_3', 'PHASE_4'] as const;
export type ReceivableEmbargoBankAccountBankPhaseType = (typeof receivableEmbargoBankAccountBankPhaseTypes)[number];
